import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import arrowIcon from './images/arrowCopy10.svg'
import {goToPage, setSelectedSubscriber, reportAnalytics} from '../../fundialSlice';

const SubscribersList = (props) => {
  const isSuspended = (props.selectedSubscriber && props.selectedSubscriber.fundialSubscriberStatus == "SUSPENDED");

  useEffect(() => {
    if(isSuspended){
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: "HN_Error_ChooseDifferentCLI",
        eventLabel: "",
      });
    }
 
  }, [isSuspended]);
  
    return (
        <div className="subscribers-list">
          <div className="header">
            {!isSuspended &&
              <>
              <h2>לאיזה מנוי ברצונכם להגדיר את שרות המתנה הנעימה?</h2>
              <p>בחרו מנוי</p>
              </>
            }
            {isSuspended &&
                <>
                <h2>המנוי שבחרתם אינו יכול להירשם לשרות זה</h2>
                <p>לפתיחת המנוי לרכישת תוכן ניתן לפנות ל- {window.Config.technicalSupportPhone}</p>
                <p>לבחירת מנוי אחר</p>
                </>
            }
          </div>
          <div className="component-separator"></div>
          <div className="subscriber-list-wrapper">
           {props.subscribers.map((subscriber, i) => (
                <>
                <button className="subscriber" onClick={() => props.onClickSubscriber(subscriber) }><span className="number">מנוי {subscriber.cli}</span><Image src={arrowIcon} /></button>
                <div className="component-separator"></div>
                </>

            ))
            }  
          </div>

        </div>
 
    );
};

const mapStateToProps = (state) => {
  return {
    subscribers: state.fundialPage.subscribers, 
    selectedSubscriber: state.fundialPage.selectedSubscriber
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedSubscriber,
  reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribersList);